import { render, staticRenderFns } from "./repairing.vue?vue&type=template&id=5280f4a0&"
import script from "./repairing.vue?vue&type=script&lang=js&"
export * from "./repairing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports